import { SlotMachineEffectT } from '../../../types';
import Coin from '../../../assets/svg/utils/coins/coin-ltr.svg';
import Energy from '../../../assets/svg/utils/energy/energy-ltr.svg';
import Revive from '../../../assets/svg/boosters/revive.svg';
import Booster from '../../../assets/svg/boosters/robot.svg';

type TGetSpinResultInfoProps = {
    effect?: SlotMachineEffectT
    isSpinning: boolean;
    energy: number;
}

const getSpinResultInfo = ({ effect, energy, isSpinning }: TGetSpinResultInfoProps) => {
  if (!effect || isSpinning) {
    return {
      icon: null,
      label: null,
    };
  }

  switch (effect.name) {
    case 'bonus':
      return {
        icon: <img src={Coin} className="w-4 h-4" alt="coin-icon" />,
        label: effect.amount,
      };
    case 'regenerate_energy':
      return {
        icon: <img src={Energy} className="w-4 h-4" alt="coin-icon" />,
        label: energy,
      };
    case 'revive':
      return {
        icon: <img src={Revive} className="w-4 h-4" alt="coin-icon" />,
        label: 'revive',
      };
    case 'reward_multiplier':
      return {
        icon: <img src={Booster} className="w-4 h-4" alt="coin-icon" />,
        label: 'booster',
      };
    case 'aviator':
      return {
        icon: <img src={Booster} className="w-4 h-4" alt="coin-icon" />,
        label: 'aviator',
      };
    default:
      return {
        icon: null,
        label: null,
      };
  }
};

export default getSpinResultInfo;
